/**
 * @file
 * Provides SMIT Unify integration.
 */

(function (Drupal, drupalSettings, $) {
  "use strict";

  Drupal.behaviors.biHcpValidationSmitUnify = Drupal.behaviors.biHcpValidationSmitUnify || {};

  Drupal.behaviors.biHcpValidationSmitUnify.attach = async (context, settings) => {

    // Make sure that biHcpvalidation behavior exists.
    if (!Drupal.behaviors.biHcpValidation) {
      return;
    }

    const _obj = Drupal.behaviors.biHcpValidationSmitUnify;
    const $loginButton = $('#smit-unify-login', context);
    const $acceptCheckbox = $('#accept-consent', context);

    // Disable the login button by default if the consent checkbox is enabled.
    const isConsentEnabled = $acceptCheckbox.length;
    $loginButton.click(async () => {
      // Only trigger login popup if consent is checked.
      if (isConsentEnabled && !$acceptCheckbox.prop('checked')) {
        return;
      }
      await _obj.loginPopup(context);
    });

    // Needed for Unify popup authentication.
    function dec2hex(dec) {
      return ("0" + dec.toString(16)).substr(-2);
    }

    function generateCodeVerifier() {
      var array = new Uint32Array(56 / 2);
      window.crypto.getRandomValues(array);
      return Array.from(array, dec2hex).join("");
    }

    function sha256(str) {
      const encoder = new TextEncoder();
      const data = encoder.encode(str);
      return window.crypto.subtle.digest("SHA-256", data);
    }

    function base64urlencode(a) {
      var str = "";
      var bytes = new Uint8Array(a);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        str += String.fromCharCode(bytes[i]);
      }
      return btoa(str)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
    }

    async function generateCodeChallengeFromVerifier(v) {
      var hashed = await sha256(v);
      var base64encoded = base64urlencode(hashed);
      return base64encoded;
    }

    async function getCodeChallenge() {
      const code_verifier = generateCodeVerifier();

      try {
        let code_challenge = await generateCodeChallengeFromVerifier(
          code_verifier
        );

        localStorage.setItem("code_verifier", code_verifier);
        localStorage.setItem('code_challenge', code_challenge);
      } catch (e) {
        //console.log(JSON.stringify(e));
      }
    }

    localStorage.setItem('code_challenge_method', 'S256');

    getCodeChallenge().then(() => {

      const UNIFY_HOSTNAME = drupalSettings.bi_smit_unify.unifyDomain;
      const UNIFY_CLIENT_ID = drupalSettings.bi_smit_unify.unifyClientId;
      const UNIFY_REDIRECT_URI = location.origin + drupalSettings.path.baseUrl + "smit_unify/callback";

      const url = new URL("/authorize", UNIFY_HOSTNAME);
      url.searchParams.set("client_id", UNIFY_CLIENT_ID);
      url.searchParams.set("response_type", 'code');
      url.searchParams.set("redirect_uri", UNIFY_REDIRECT_URI);
      url.searchParams.set("code_challenge_method", localStorage.getItem('code_challenge_method'));
      url.searchParams.set("code_challenge", localStorage.getItem('code_challenge'));
      url.searchParams.set('state', btoa(JSON.stringify({'return_to': location.origin})));
      localStorage.setItem("unify_login_url", url);
    });

    // Listen for access token from popup.
    window.addEventListener("message", smitUnifyHcpLogin, false);

    async function smitUnifyHcpLogin(event) {
      if (event.origin !== window.location.origin) {
        return;
      }

      if (event.data.access_token !== undefined) {
        $(once('handle-postlogin', 'body', context)).each( async () => {
          const handlePostLogin = Drupal.ajax({
            url: Drupal.url('smit_unify/handle_postlogin'),
            method: 'POST',
            submit: {
              'postLoginToken': drupalSettings.bi_smit_unify.postLoginToken,
              'accessToken': event.data.access_token,
              'current_path': drupalSettings.path.currentPath,
              'query_string': drupalSettings.path.currentQuery
            },
            error: function (xmlhttprequest, uri, message) {
              console.log(xmlhttprequest, uri, message);
            }
          });
          try {
            await handlePostLogin.execute();
          } catch (error) {
            console.log(error);
          }
        });
      }

    }

    /**
     * Open Unify login in a popup window.
     */
    Drupal.behaviors.biHcpValidationSmitUnify.loginPopup = async (context = document) => {
      const url = localStorage.getItem("unify_login_url");
      const features = {
        popup: "yes",
        width: 600,
        height: 700,
        top: "auto",
        left: "auto",
        toolbar: "no",
        menubar: "no",
      };

      const strWindowsFeatures = Object.entries(features)
        .reduce((str, [key, value]) => {
          if (value == "auto") {
            if (key === "top") {
              const v = Math.round(
                window.innerHeight / 2 - features.height / 2
              );
              str += `top=${v},`;
            } else if (key === "left") {
              const v = Math.round(
                window.innerWidth / 2 - features.width / 2
              );
              str += `left=${v},`;
            }
            return str;
          }

          str += `${key}=${value},`;
          return str;
        }, "")
        .slice(0, -1);

      window.open(url, "_blank", strWindowsFeatures);
    }



  };

})(Drupal, drupalSettings, jQuery);
